import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/iview.js'

import Vant from 'vant';
import 'vant/lib/index.css';
import { Swipe, SwipeItem } from 'vant';
import { Field } from 'vant';
import { Tab, Tabs } from 'vant';
import { PasswordInput, NumberKeyboard } from 'vant';
import { Toast } from 'vant';
import { Circle } from 'vant';
import { DropdownMenu, DropdownItem } from 'vant';
import { Dialog  } from 'vant';
import { RadioGroup, Radio,PullRefresh  } from 'vant';

Vue.use(PullRefresh);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Vant);
Vue.use(Swipe).use(SwipeItem);
Vue.use(Field);
Vue.config.productionTip = false;
Vue.use(Tab).use(Tabs);
Vue.use(PasswordInput).use(NumberKeyboard);
Vue.use(Toast);
Vue.use(Circle);
Vue.use(DropdownMenu).use(DropdownItem);
Vue.use(Dialog)


//挂载封装的请求(3.0)
// import { post, get } from './axios/index';
// Vue.prototype.$post = post;
// Vue.prototype.$get = get;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
